import { dataFetcher } from 'core/services/requestHandler';   

const getSubscriptions = async (data = {}, config = {}) => {
  return dataFetcher('subscriptions', data, {...config});
};

export { getSubscriptions };
